import React from 'react';
import { m as motion } from 'framer-motion';
import { Card, vars, Text, textVariants, LinkButton } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { CaretDown } from '@phosphor-icons/react';
import { useToggle } from '../../../../common/custom-hooks/toggle';

const motionVariants = {
  show: {
    height: 'auto',
    transitionEnd: { overflow: 'visible' },
  },
  hide: {
    overflow: 'hidden',
    height: 0,
  },
};

const cardStyles = css`
  cursor: pointer;
  padding: 16px 16px 0;
`;

const caretDownStyles = (isOpen: boolean) => css`
  transform: rotateX(${isOpen ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;

const cardSectionStyles = (isOpen: boolean) => css`
  border-bottom: 0 solid ${vars.colors.divider};
  ${isOpen && 'border-width: 1px; transition: border-width 0.2s linear'};
  display: flex;
  justify-content: space-between;
`;

const textStyles = css`
  margin-right: 4px;
`;

const linkButtonStyles = css`
  display: flex;
  margin-top: 2px;
`;
interface BrandedFareV1Props {
  brandedFareName?: string;
  children: React.ReactNode;
}
const BrandedFareV1 = ({ brandedFareName, children }: BrandedFareV1Props) => {
  const { isOpen, handleToggle } = useToggle();
  const { t } = useTranslation();
  analytics.useLogMouseFlowTagEffect('Branded fare details', isOpen);
  return (
    <Card className={cardStyles} data-testid="branded-fare-v1">
      <Card.Section className={cardSectionStyles(isOpen)} onClick={handleToggle}>
        <Text variant={textVariants._16_BOLD}>{brandedFareName}</Text>
        <LinkButton className={linkButtonStyles} data-testid="brandedFare-accordion-link">
          <Text className={textStyles}>{t('PaymentPage.BrandedFare.AccordionLink.Label')}</Text>
          <CaretDown className={caretDownStyles(isOpen)} size={20} weight="light" />
        </LinkButton>
      </Card.Section>
      <motion.div
        animate={isOpen ? 'show' : 'hide'}
        data-testid="payment-page-branded-fare-v1"
        initial={false}
        transition={{ type: 'ease-in-out', duration: 0.4 }}
        variants={motionVariants}
      >
        <Card.Section data-testid="brandedFare-accordion-features">{children}</Card.Section>
      </motion.div>
    </Card>
  );
};
export default BrandedFareV1;
